<p>service-report-for-products-list works!</p>
